import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_ORIGIN = 'https://cases.wazn.sa';

const CLIENT_META = {
  title: 'منصة وازن | بوابة القضايا العمالية',
  description: 'بوابة مخصصة لاستقبال ومتابعة طلبات القضايا العمالية بسرية واحترافية.',
  url: SITE_ORIGIN,
  image: `${SITE_ORIGIN}/images/labor-og-image.jpg`,
  siteName: 'cases.wazn.sa',
  robots: 'index, follow',
};

const ADMIN_META = {
  title: 'وازن | مركز العمليات القانونية',
  description: 'لوحة إدارة ومتابعة القضايا والطلبات القانونية الداخلية.',
  url: `${SITE_ORIGIN}/admin`,
  image: `${SITE_ORIGIN}/images/legal-operations-og-image.jpg`,
  siteName: 'مركز العمليات القانونية',
  robots: 'noindex, nofollow',
};

const WORKSPACE_META = {
  title: 'وازن | مساحة العمل القانونية',
  description: 'مساحة العمل الداخلية لمراجعة ملفات القضايا ومتابعة سير العمل القانوني.',
  url: `${SITE_ORIGIN}/cases/login`,
  image: `${SITE_ORIGIN}/images/legal-workspace-og-image.jpg`,
  siteName: 'مساحة العمل القانونية',
  robots: 'noindex, nofollow',
};

const WORKSPACE_PATHS = ['/cases', '/staff', '/legal-operations', '/dashboard/labor-cases'];

export const getRouteMetadata = (pathname) => {
  if (WORKSPACE_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`))) {
    return WORKSPACE_META;
  }
  if (pathname === '/admin' || pathname.startsWith('/admin/')) {
    return ADMIN_META;
  }
  return CLIENT_META;
};

const RouteMetadata = () => {
  const { pathname } = useLocation();
  const meta = getRouteMetadata(pathname);

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="robots" content={meta.robots} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="ar_SA" />
      <meta property="og:site_name" content={meta.siteName} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={meta.url} />
      <meta property="og:image" content={meta.image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:alt" content={meta.title} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={meta.image} />
      <meta name="twitter:image:alt" content={meta.title} />
      <link rel="canonical" href={meta.url} />
    </Helmet>
  );
};

export default RouteMetadata;
